"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSSHUserCreate = exports.initSSHUser = exports.RESTRICTED_USERS = void 0;
var initSSHUserCreate = exports.initSSHUserCreate = function initSSHUserCreate() {
  return {
    id: {
      value: "NOT_SET"
    },
    username: "NOT_SET",
    publicKeys: [],
    userfulKeys: false
  };
};
var initSSHUser = exports.initSSHUser = function initSSHUser() {
  return {
    id: {
      value: "NOT_SET"
    },
    username: "NOT_SET",
    uid: 0,
    gid: 0,
    homeDir: "NOT_SET",
    publicKeys: [],
    userfulKeys: false
  };
};
var RESTRICTED_USERS = exports.RESTRICTED_USERS = ["root", "files", "bin", "daemon", "adm", "lp", "mail", "operator", "games", "ftp", "nobody", "nginx", "tss", "systemd-coredump", "dbus", "polkitd", "rtkit", "pipewire", "avahi", "sshd", "chrony", "dhcpd", "grafana", "prometheus", "td-agent", "geoclue", "pulse", "flatpak", "sssd", "akmods", "openvpn", "userful-zeroclient", "systemd-oom"];